import isString from "lodash/isString";
import moment from "moment-timezone";

export const isTracked = objectKind => {
  return isString(objectKind) && objectKind.length > 0;
};

export const toJST = unix => {
  let momentObjJst = moment(unix, "X").tz("Asia/Tokyo");
  return momentObjJst.format("YYYY/MM/DD/ HH:mm");
};

export const formatObjectRecognitionRate = (kind, confidence) => {
  const kindNameJa = getObjectKindJa(kind) || " --- ";
  const rate = confidence || " --- ";
  return `${kindNameJa} (${rate}%)`;
};

export const getObjectKindJa = objectKind => {
  const kindMapping = {
    ship: "船舶",
    cargo: "貨物船",
    crane: "クレーン船",
    barge: "バージ",
    tug: "タグボート",
    passenger: "旅客船",
    fishing: "漁船",
    boat: "小型船",
    buoy: "ブイ",
    ambiguous: "種別不明",
    floating: "浮遊物",
    pleasure: "プレジャー",
  };

  return kindMapping[objectKind] || " --- ";
};

export default {
  formatObjectRecognitionRate,
  getObjectKindJa,
};
